<section class="jumbotron text-center" style="padding:2em;">
  <div class="container">
    <h1 class="jumbotron-heading">Building on three generations of experience ...</h1>
<!--
    <div class="card align-content-center text-center mx-auto d-block" style="max-width: 600px; margin: 4em;">
      <img src="/assets/images/Portfolio/017c.jpg" class="card-img-top img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent">
    </div>
  -->
    <div class="row">
      <div class="col-md-6 first">
          <div class="card mb-6 shadow-sm">
              <div class="card-image">
                  <img src="/assets/images/Portfolio/017c.jpg" class="card-img-top"  alt="Sun room">
              </div>
          </div>
      </div>

      <div class="col-md-6">
        <div class="card mb-6 shadow-sm">
            <div class="card-image">
                <img src="/assets/images/Portfolio/2_0.jpg" class="card-img-top" alt="Renovated oast house">
            </div>
        </div>
    </div>
  </div><!-- end row class -->

    <p class="lead text-muted">
      <a href="/portfolio/1">Renovation</a>, <a href="/portfolio/5">conversion</a> and <a href="/portfolio/2">extension</a> projects 
      of all types & sizes are regularly carried out. Many are on older & larger domestic properties including listed buildings. 
      More modern buildings are also worked on, to create that missing ‘space or feature’, which makes your property special. 
      A full maintenance programme is also offered & carried out. The construction of new buildings is also undertaken.
    </p>
    <p>
      <a routerLink="/contact" class="btn btn-primary my-2">Contact</a>
      &nbsp;
      <a href="/portfolio" class="btn btn-secondary my-2">Portfolio</a>
    </p>
  </div>
</section>

<app-portfolio [itemCount]=6 [showText]=true></app-portfolio>

<div class="container" style="margin-top: 1em;">
  <p class="border-highlight">
    Should you wish to find out more or arrange a site meeting to discuss your project, please call Jon on <a href="tel:07778808950">07778 808950</a> 
    or <a routerLink="/contact">email</a>.  
  </p>         
</div> 

<!--
<div class="toast" role="alert" autohide="false" aria-live="assertive" aria-atomic="true" style="position: relative; min-height: 200px;">
  <div class="toast-header">
    <img src="..." class="rounded mr-2" alt="...">
    <strong class="mr-auto">Bootstrap</strong>
    <small class="text-muted">11 mins ago</small>
    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="toast-body">
    Hello, world! This is a toast message.
  </div>
</div>
-->